"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedBooleanValues = exports.CartDiscountCustomFields = exports.externalTaxCountries = exports.idMeCartDiscountKey = exports.IdMeGroups = exports.DEFAULT_SALES_BADGE_BACKGROUND_COLOUR = exports.DEFAULT_SALES_OVERRIDE_BADGE_BACKGROUND_COLOUR = exports.DEFAULT_BADGE_BACKGROUND_COLOUR = exports.DEFAULT_BADGE_TEXT_COLOUR = exports.BadgeType = exports.AddressCustomFields = exports.LineItemCustomFields = exports.OrderCustomFields = exports.UserType = exports.ClarksChannel = exports.CountryIdentifier = exports.StoreCurrenciesMap = exports.Star2Store = exports.Store = exports.PaymentMethod = exports.CustomObjectContainer = exports.InventoryCustomFields = exports.CustomerCustomField = exports.StoreMarketingPreference = exports.shippingTypesDict = exports.ShippingTypesKeys = exports.ShippingTypes = exports.DeliveryTypes = exports.DeliveryInstructions = exports.ShippingCustomFields = exports.PrimaryCategoryCustomFields = exports.StoreCustomFields = exports.CategoryCustomFields = exports.PriceCustomField = exports.variantAttributes = exports.coreAttributes = exports.productTypes = void 0;
exports.productTypes = __importStar(require("./product-types"));
exports.coreAttributes = __importStar(require("./product-types/core-attributes"));
exports.variantAttributes = __importStar(require("./product-types/variant-attributes"));
__exportStar(require("./common/i18n"), exports);
__exportStar(require("./product-types/common"), exports);
__exportStar(require("./cart-types"), exports);
var PriceCustomField;
(function (PriceCustomField) {
    PriceCustomField["THEN_PRICE"] = "thenPrice";
    PriceCustomField["WAS_PRICE"] = "wasPrice";
    PriceCustomField["SAVING_VALUE_PRICE"] = "savingValuePrice";
    PriceCustomField["SALE_DISCOUNT_PERCENTAGE"] = "saleDiscountPercentage";
    PriceCustomField["THEN_PRICE_VALID_FROM"] = "thenPriceValidFrom";
    PriceCustomField["THEN_PRICE_VALID_UNTIL"] = "thenPriceValidUntil";
    PriceCustomField["WAS_PRICE_VALID_FROM"] = "wasPriceValidFrom";
    PriceCustomField["WAS_PRICE_VALID_UNTIL"] = "wasPriceValidUntil";
    /**
     * @deprecated This Type is not used anymore
     */
    PriceCustomField["LAST_OFFERED_AT_DATE"] = "lastOfferedAtDate";
    /**
     * @deprecated This Type is not used anymore
     */
    PriceCustomField["FROM_DATE"] = "fromDate";
    /**
     * @deprecated This Type is not used anymore
     */
    PriceCustomField["TO_DATE"] = "toDate";
})(PriceCustomField || (exports.PriceCustomField = PriceCustomField = {}));
var CategoryCustomFields;
(function (CategoryCustomFields) {
    CategoryCustomFields["QUICK_LINKS"] = "quickLinks";
    CategoryCustomFields["INDEX"] = "index";
    CategoryCustomFields["FOLLOW"] = "follow";
    CategoryCustomFields["PARENT_FAMILY_KEY"] = "parentFamilyKey";
    CategoryCustomFields["IS_PRIVATE"] = "isPrivate";
    CategoryCustomFields["CATEGORY_SLUG"] = "categorySlug";
    CategoryCustomFields["BADGES"] = "badges";
    CategoryCustomFields["H1TEXT"] = "h1Text";
})(CategoryCustomFields || (exports.CategoryCustomFields = CategoryCustomFields = {}));
var StoreCustomFields;
(function (StoreCustomFields) {
    StoreCustomFields["SKU_CAP"] = "skuCap";
    StoreCustomFields["PRODUCT_QTY_CAP"] = "productQtyCap";
    StoreCustomFields["BASKET_VALUE_CAP"] = "basketValueCap";
    StoreCustomFields["BASKET_VALUE_CAP_AT_PEAK"] = "basketValueCapAtPeak";
    StoreCustomFields["BASKET_VALUE_CAP_PEAK_FROM"] = "basketValueCapPeakFrom";
    StoreCustomFields["BASKET_VALUE_CAP_PEAK_UNTIL"] = "basketValueCapPeakUntil";
    StoreCustomFields["ROOT_CATEGORY"] = "rootCategory";
    StoreCustomFields["SITE_SWITCH_ENABLED"] = "siteSwitchEnabled";
    StoreCustomFields["COUNTRY_NAME"] = "countryName";
    StoreCustomFields["CURRENCY_SYMBOL"] = "currencySymbol";
    StoreCustomFields["CURRENCY"] = "currency";
    StoreCustomFields["PAYMENT_METHODS"] = "paymentMethods";
    StoreCustomFields["SHIPPING_COUNTRIES"] = "shippingCountries";
    StoreCustomFields["BILLING_COUNTRIES"] = "billingCountries";
    StoreCustomFields["MARKETING_PREFERENCES"] = "marketingPreferences";
    StoreCustomFields["MARKETING_PREFERENCES_DEFAULT_ENABLED"] = "marketingPreferenceDefaultEnabled";
    StoreCustomFields["COUNTRY_IDENTIFIER"] = "countryIdentifier";
    StoreCustomFields["MERCHANT_ACCOUNT_MOTO"] = "customerServiceMerchantAccount";
    StoreCustomFields["MERCHANT_ACCOUNT_ECOM"] = "ecommerceMerchantAccount";
    StoreCustomFields["COLLECTION_SHIPPING_ENABLED"] = "collectionShippingEnabled";
    StoreCustomFields["PUDO_ENABLED"] = "pudoEnabled";
    StoreCustomFields["THREE_D_SECURE_ENABLED"] = "3DS_enabled";
    StoreCustomFields["BACK_IN_STOCK_NOTIFICATIONS_DISABLED"] = "backInStockNotificationsDisabled";
    StoreCustomFields["MINIMUM_STOCK_FOR_SENDING_BACK_IN_STOCK_EMAILS"] = "minimumStockForSendingBackInStockEmails";
    StoreCustomFields["PDP_DELIVERY_OPTIONS_ENABLED"] = "pdpDeliveryOptionsEnabled";
    StoreCustomFields["BASKET_DELIVERY_OPTIONS_ENABLED"] = "basketDeliveryOptionsEnabled";
    StoreCustomFields["PRODUCT_TRUE_FIT_ENABLED"] = "productTrueFitEnabled";
    StoreCustomFields["BOPIS_ENABLED"] = "bopisEnabled";
    StoreCustomFields["ORDER_SHIPPING_EMAIL_ENABLED"] = "orderShippingEmailEnabled";
    StoreCustomFields["USE_AS_STOCK_THRESHOLD_PERCENTAGE"] = "useAsStockThresholdPercentage";
    StoreCustomFields["LOW_STOCK_THRESHOLD"] = "lowStockThreshold";
    StoreCustomFields["HIGH_STOCK_THRESHOLD"] = "highStockThreshold";
    StoreCustomFields["PRICES_STRIKETHROUGH"] = "pricesStrikethrough";
})(StoreCustomFields || (exports.StoreCustomFields = StoreCustomFields = {}));
var PrimaryCategoryCustomFields;
(function (PrimaryCategoryCustomFields) {
    PrimaryCategoryCustomFields["SCOPE"] = "scope";
    PrimaryCategoryCustomFields["DATA"] = "data";
})(PrimaryCategoryCustomFields || (exports.PrimaryCategoryCustomFields = PrimaryCategoryCustomFields = {}));
var ShippingCustomFields;
(function (ShippingCustomFields) {
    ShippingCustomFields["DELIVERY_TYPE"] = "deliveryType";
    ShippingCustomFields["DELIVERY_PRIORITY"] = "deliveryPriority";
    ShippingCustomFields["SHIPPING_TYPE"] = "shippingType";
    ShippingCustomFields["DELIVERY_TIME_AFTER_CUTOFF_TIME"] = "deliveryTimeAfterCutoffHour";
    ShippingCustomFields["FULFILLMENT_GROUPS_IDS"] = "fulfillmentGroupsIds";
    ShippingCustomFields["DELIVERY_TIME"] = "deliveryTime";
    ShippingCustomFields["SERVICE_CLASS"] = "serviceClass";
    ShippingCustomFields["IS_OUTLET_SHIPPING_TYPE"] = "isOutletShippingType";
    ShippingCustomFields["DELIVERY_ORDER"] = "deliveryOrder";
    ShippingCustomFields["GE_B2B_SHIPPING_PRICE"] = "geB2bShippingPrice";
    ShippingCustomFields["GE_SHIPPING_METHOD_CODE"] = "geShippingMethodCode";
    ShippingCustomFields["GE_SHIPPING_METHOD_NAME"] = "geShippingMethodName";
    ShippingCustomFields["GE_DELIVERY_DATE_TO"] = "geDeliveryDateTo";
})(ShippingCustomFields || (exports.ShippingCustomFields = ShippingCustomFields = {}));
var DeliveryInstructions;
(function (DeliveryInstructions) {
    DeliveryInstructions["RECEPTION"] = "Leave at reception";
    DeliveryInstructions["NEIGHBOUR"] = "Leave with neighbour";
    DeliveryInstructions["SAFE_PLACE"] = "Leave in a safe place";
    DeliveryInstructions["OTHER"] = "Other";
})(DeliveryInstructions || (exports.DeliveryInstructions = DeliveryInstructions = {}));
var DeliveryTypes;
(function (DeliveryTypes) {
    DeliveryTypes["HD"] = "HD";
    DeliveryTypes["CFS"] = "CFS";
    DeliveryTypes["PUDO"] = "PUDO";
})(DeliveryTypes || (exports.DeliveryTypes = DeliveryTypes = {}));
var ShippingTypes;
(function (ShippingTypes) {
    ShippingTypes["HOME"] = "Home";
    ShippingTypes["HOME_DEFAULT"] = "Home default";
    ShippingTypes["COLLECTION"] = "Collection";
    ShippingTypes["NOT_USED"] = "Not used";
    ShippingTypes["PUDO"] = "PUDO";
    ShippingTypes["DIGITAL"] = "Digital";
})(ShippingTypes || (exports.ShippingTypes = ShippingTypes = {}));
var ShippingTypesKeys;
(function (ShippingTypesKeys) {
    ShippingTypesKeys["HOME"] = "home";
    ShippingTypesKeys["HOME_DEFAULT"] = "home-default";
    ShippingTypesKeys["COLLECTION"] = "collection";
    ShippingTypesKeys["NOT_USED"] = "not-used";
    ShippingTypesKeys["PUDO"] = "pudo";
    ShippingTypesKeys["DIGITAL"] = "digital";
})(ShippingTypesKeys || (exports.ShippingTypesKeys = ShippingTypesKeys = {}));
exports.shippingTypesDict = {
    [ShippingTypesKeys.HOME]: ShippingTypes.HOME,
    [ShippingTypesKeys.HOME_DEFAULT]: ShippingTypes.HOME_DEFAULT,
    [ShippingTypesKeys.COLLECTION]: ShippingTypes.COLLECTION,
    [ShippingTypesKeys.NOT_USED]: ShippingTypes.NOT_USED,
    [ShippingTypesKeys.PUDO]: ShippingTypes.PUDO,
    [ShippingTypesKeys.DIGITAL]: ShippingTypes.DIGITAL,
};
var StoreMarketingPreference;
(function (StoreMarketingPreference) {
    StoreMarketingPreference["WOMENS"] = "womens";
    StoreMarketingPreference["MENS"] = "mens";
    StoreMarketingPreference["KIDS"] = "kids";
    StoreMarketingPreference["ORIGINALS"] = "originals";
    StoreMarketingPreference["OUTLET"] = "outlet";
})(StoreMarketingPreference || (exports.StoreMarketingPreference = StoreMarketingPreference = {}));
var CustomerCustomField;
(function (CustomerCustomField) {
    CustomerCustomField["PHONE"] = "phone";
    CustomerCustomField["SIGNUP_REGION"] = "signupRegion";
    CustomerCustomField["CHANNEL"] = "channel";
    CustomerCustomField["REGISTERED_FROM"] = "registeredFrom";
    CustomerCustomField["GENDER"] = "gender";
    CustomerCustomField["SHOE_SIZE"] = "shoeSize";
    CustomerCustomField["SHOE_WIDTH"] = "shoeWidth";
    CustomerCustomField["ARE_CUSTOMER_CARD_DETAILS_SAVED"] = "areCustomerCardDetailsSaved";
    CustomerCustomField["USER_TYPE"] = "userType";
    CustomerCustomField["SAVED_STORES_IDS"] = "savedStoresIds";
    CustomerCustomField["DEFAULT_STORE_ID"] = "defaultStoreId";
    CustomerCustomField["LOYALTY_ID_OPT_IN"] = "loyaltyIdOptIn";
    CustomerCustomField["POSTAL_CONSENT"] = "postalConsent";
    CustomerCustomField["PHONE_CONSENT"] = "phoneConsent";
    CustomerCustomField["EMAIL_CONSENT"] = "emailConsent";
    CustomerCustomField["REGISTERED_FROM_STORE"] = "registeredFromStore";
    CustomerCustomField["SOURCE"] = "source";
    CustomerCustomField["ANONYMIZED"] = "anonymized";
    CustomerCustomField["ORIGINAL_EMAIL"] = "originalEmail";
    CustomerCustomField["COUNTRY_ALIAS"] = "countryAlias";
    CustomerCustomField["LANGUAGE_PREFERENCE"] = "languagePreference";
    CustomerCustomField["METHOD"] = "method";
    CustomerCustomField["PREFERENCES"] = "preferences";
    CustomerCustomField["SUBSCRIPTIONS"] = "subscriptions";
    CustomerCustomField["EXTENDED_PROPERTIES"] = "extendedProperties";
})(CustomerCustomField || (exports.CustomerCustomField = CustomerCustomField = {}));
var InventoryCustomFields;
(function (InventoryCustomFields) {
    InventoryCustomFields["RESERVED"] = "reserved";
})(InventoryCustomFields || (exports.InventoryCustomFields = InventoryCustomFields = {}));
var CustomObjectContainer;
(function (CustomObjectContainer) {
    CustomObjectContainer["UNVERIFIED_CUSTOMER_DATA"] = "unverified-customer-data";
    CustomObjectContainer["BADGE_DATA"] = "badge-data";
})(CustomObjectContainer || (exports.CustomObjectContainer = CustomObjectContainer = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["PAYPAL"] = "payPal";
    PaymentMethod["GPAY"] = "gPay";
    PaymentMethod["MATERCARD"] = "masterCard";
    PaymentMethod["VISA"] = "visa";
    PaymentMethod["KLARNA"] = "klarna";
    PaymentMethod["AMEX"] = "amex";
    PaymentMethod["GIFT_CARD"] = "giftCard";
    PaymentMethod["APPLE_PAY"] = "applePay";
    PaymentMethod["DINERS"] = "diners";
    PaymentMethod["EPS"] = "eps";
    PaymentMethod["SOFORTUBERWEISUNG"] = "sofortuberweisung";
    PaymentMethod["MISTERCASH_MOBILE"] = "mistercashMobile";
    PaymentMethod["MOBILE_PAY"] = "mobilePay";
    PaymentMethod["GIRO_PAY"] = "giroPay";
    PaymentMethod["IDEAL"] = "iDeal";
    PaymentMethod["REVOLUT"] = "revolut";
    PaymentMethod["DOT_PAY"] = "dotPay";
    PaymentMethod["PRZELEWY24"] = "przelewy24";
    PaymentMethod["TWINT"] = "twint";
    PaymentMethod["TRUSTLY"] = "trustly";
    PaymentMethod["VISADANKORT"] = "visaDankort";
    PaymentMethod["DISCOVER"] = "discover";
    PaymentMethod["JCB"] = "jcb";
    PaymentMethod["GLOBAL_E"] = "globalE";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
var Store;
(function (Store) {
    Store["UK"] = "uk";
    Store["UK_OUTLET"] = "outlet-uk";
    Store["US"] = "us";
    Store["ROI"] = "roi";
    Store["CA"] = "ca";
    Store["DE"] = "de";
    Store["IT"] = "it";
    Store["FR"] = "fr";
    Store["NL"] = "nl";
    Store["ES"] = "es";
    Store["ROE_CH"] = "roe-ch";
    Store["ROE_PL"] = "roe-pl";
    Store["ROE_DK"] = "roe-dk";
    Store["ROE_BE"] = "roe-be";
    Store["ROE_AT"] = "roe-at";
    Store["ROE_LU"] = "roe-lu";
    Store["ROE_SM"] = "roe-sm";
    Store["ROE"] = "roe";
    Store["ROE_SCAND"] = "roe-scand";
})(Store || (exports.Store = Store = {}));
var Star2Store;
(function (Star2Store) {
    Star2Store["DE"] = "de";
    Star2Store["IT"] = "it";
    Star2Store["FR"] = "fr";
    Star2Store["NL"] = "nl";
    Star2Store["ES"] = "es";
    Star2Store["ROE_CH"] = "roe-ch";
    Star2Store["ROE_PL"] = "roe-pl";
    Star2Store["ROE_DK"] = "roe-dk";
    Star2Store["ROE_BE"] = "roe-be";
    Star2Store["ROE_AT"] = "roe-at";
    Star2Store["ROE_LU"] = "roe-lu";
    Star2Store["ROE_SM"] = "roe-sm";
    Star2Store["ROE_SCAND"] = "roe-scand";
    Star2Store["ROE"] = "roe";
})(Star2Store || (exports.Star2Store = Star2Store = {}));
exports.StoreCurrenciesMap = {
    UK: 'GBP',
    UK_OUTLET: 'GBP',
    US: 'USD',
    ROI: 'EUR',
    CA: 'CAD',
    DE: 'EUR',
    IT: 'EUR',
    FR: 'EUR',
    NL: 'EUR',
    ES: 'EUR',
    ROE_CH: 'CHF',
    ROE_PL: 'PLN',
    ROE_DK: 'DKK',
    ROE_BE: 'EUR',
    ROE_AT: 'EUR',
    ROE_LU: 'EUR',
    ROE_SM: 'EUR',
    ROE_SCAND: 'EUR',
    ROE: 'EUR',
};
var CountryIdentifier;
(function (CountryIdentifier) {
    CountryIdentifier["UK"] = "uk";
    CountryIdentifier["IE"] = "ie";
    CountryIdentifier["US"] = "us";
    CountryIdentifier["CA"] = "ca";
    CountryIdentifier["FR"] = "fr";
    CountryIdentifier["DE"] = "de";
    CountryIdentifier["IT"] = "it";
    CountryIdentifier["ES"] = "es";
    CountryIdentifier["NL"] = "nl";
    CountryIdentifier["AT"] = "at";
    CountryIdentifier["BE"] = "be";
    CountryIdentifier["BA"] = "ba";
    CountryIdentifier["BG"] = "bg";
    CountryIdentifier["HR"] = "hr";
    CountryIdentifier["CY"] = "cy";
    CountryIdentifier["CZ"] = "cz";
    CountryIdentifier["DK"] = "dk";
    CountryIdentifier["EE"] = "ee";
    CountryIdentifier["FI"] = "fi";
    CountryIdentifier["GE"] = "ge";
    CountryIdentifier["GI"] = "gi";
    CountryIdentifier["GR"] = "gr";
    CountryIdentifier["HU"] = "hu";
    CountryIdentifier["IL"] = "il";
    CountryIdentifier["LV"] = "lv";
    CountryIdentifier["LI"] = "li";
    CountryIdentifier["LT"] = "lt";
    CountryIdentifier["LU"] = "lu";
    CountryIdentifier["MT"] = "mt";
    CountryIdentifier["MC"] = "mc";
    CountryIdentifier["ME"] = "me";
    CountryIdentifier["MK"] = "mk";
    CountryIdentifier["NO"] = "no";
    CountryIdentifier["PL"] = "pl";
    CountryIdentifier["PT"] = "pt";
    CountryIdentifier["MD"] = "md";
    CountryIdentifier["RO"] = "ro";
    CountryIdentifier["SM"] = "sm";
    CountryIdentifier["RS"] = "rs";
    CountryIdentifier["SK"] = "sk";
    CountryIdentifier["SI"] = "si";
    CountryIdentifier["SE"] = "se";
    CountryIdentifier["CH"] = "ch";
    CountryIdentifier["TR"] = "tr";
})(CountryIdentifier || (exports.CountryIdentifier = CountryIdentifier = {}));
var ClarksChannel;
(function (ClarksChannel) {
    ClarksChannel["FULL_PRICE"] = "fullPrice";
    ClarksChannel["OUTLET"] = "outlet";
})(ClarksChannel || (exports.ClarksChannel = ClarksChannel = {}));
var UserType;
(function (UserType) {
    UserType["REGISTERED"] = "Registered";
    UserType["GUEST"] = "Guest";
})(UserType || (exports.UserType = UserType = {}));
var OrderCustomFields;
(function (OrderCustomFields) {
    OrderCustomFields["DELIVERY_INSTRUCTION_TYPE"] = "deliveryInstructionType";
    OrderCustomFields["DELIVERY_INSTRUCTION_MESSAGE"] = "deliveryInstructionMessage";
    OrderCustomFields["DELIVERY_INFO"] = "deliveryInfo";
    OrderCustomFields["IS_CSA"] = "isCsa";
    OrderCustomFields["CSA_TOKEN"] = "csaToken";
    OrderCustomFields["ID_ME_GROUPS"] = "idMeGroups";
    OrderCustomFields["SHIPPING_TYPE"] = "shippingType";
    OrderCustomFields["INVALID_TAX_ESTIMATION"] = "invalidTaxEstimation";
    OrderCustomFields["REQUESTED_SHIPPING_METHOD"] = "requestedShippingMethod";
    OrderCustomFields["GE_B2B_BILLING_ADDRESS"] = "geB2bBillingAddress";
    OrderCustomFields["GE_B2B_SHIPPING_ADDRESS"] = "geB2bShippingAddress";
    OrderCustomFields["GE_B2B_CURRENCY_CODE"] = "geB2bCurrencyCode";
    OrderCustomFields["GE_ORDER_ID"] = "geOrderId";
    OrderCustomFields["GE_CUSTOMER_COMMENT"] = "geCustomerComment";
    OrderCustomFields["GE_B2B_ORDER_DUTIES"] = "geB2bOrderDuties";
    OrderCustomFields["GE_B2B_VAT_RATE"] = "geB2bVATRate";
    OrderCustomFields["GE_CUSTOMER_CURRENCY_DISCOUNT_AMOUNT"] = "geCustomerCurrencyDiscountAmount";
    OrderCustomFields["GE_B2C_DUTIES_GUARANTEED"] = "geB2cDutiesGuaranteed";
    OrderCustomFields["GE_B2C_DUTIES"] = "geB2cDuties";
    OrderCustomFields["GE_B2C_SALES_TAXES"] = "geB2cSalesTaxes";
    OrderCustomFields["GE_B2B_SHIPPING_PRICE"] = "geB2bShippingPrice";
    OrderCustomFields["GE_SHIPPING_METHOD_CODE"] = "geShippingMethodCode";
    OrderCustomFields["GE_SHIPPING_METHOD_NAME"] = "geShippingMethodName";
    OrderCustomFields["GE_DELIVERY_DATE_TO"] = "geDeliveryDateTo";
    OrderCustomFields["GE_TAX_CALCULATION_RULE"] = "geTaxCalculationRule";
    OrderCustomFields["GE_IMPORTER_COMPANY"] = "geImporterCompany";
    OrderCustomFields["GE_IMPORTER_VAT_REGISTRATION_NUMBER"] = "geImporterVATRegistrationNumber";
    OrderCustomFields["GE_IMPORTER_CUSTOMER_TAX_ID"] = "geImporterCustomerTaxId";
    OrderCustomFields["GE_B2C_TOTAL_DUTIES_PRICE"] = "geB2cTotalDutiesPrice";
    OrderCustomFields["GE_IS_FREE_SHIPPING"] = "geIsFreeShipping";
    OrderCustomFields["GE_FREE_SHIPPING_COUPON_CODE"] = "geFreeShippingCouponCode";
    OrderCustomFields["RIS_SESSION_ID"] = "risSessionId";
    OrderCustomFields["RIS_TRANSACTION_ID"] = "risTransactionId";
    OrderCustomFields["AFFILIATE_TRACKING"] = "affiliateTracking";
    /**
     * Storefront locale field. Override cart locale where it doesn't match storefront locale.
     */
    OrderCustomFields["STOREFRONT_LOCALE"] = "storefrontLocale";
})(OrderCustomFields || (exports.OrderCustomFields = OrderCustomFields = {}));
var LineItemCustomFields;
(function (LineItemCustomFields) {
    LineItemCustomFields["GIFT_CARD_RECIPIENT"] = "giftCardRecipient";
    LineItemCustomFields["GIFT_CARD_MESSAGE"] = "giftCardMessage";
    LineItemCustomFields["GIFT_CARD_SENDER"] = "giftCardSender";
    LineItemCustomFields["GIFT_CARD_RECIPIENT_EMAIL"] = "giftCardRecipientEmail";
    LineItemCustomFields["GE_B2B_VAT_RATE"] = "geB2bVATRate";
    LineItemCustomFields["GE_B2B_LINE_ITEM_PRICE"] = "geB2bLineItemPrice";
    LineItemCustomFields["GE_B2B_DISCOUNTED_PRICE"] = "geB2bDiscountedPrice";
    LineItemCustomFields["GE_B2C_DUTIES"] = "geB2cDuties";
    LineItemCustomFields["GE_B2C_SALES_TAXES"] = "geB2cSalesTaxes";
    LineItemCustomFields["GE_B2C_CUSTOM_FEES"] = "geB2cCustomFees";
    LineItemCustomFields["GE_CUSTOMER_CURRENCY_DISCOUNT_AMOUNT"] = "geCustomerCurrencyDiscountAmount";
    LineItemCustomFields["GE_ITEM_PRICE_FOR_CUSTOMS"] = "geItemPriceForCustoms";
})(LineItemCustomFields || (exports.LineItemCustomFields = LineItemCustomFields = {}));
var AddressCustomFields;
(function (AddressCustomFields) {
    AddressCustomFields["COUNTRY_ALIAS"] = "countryAlias";
    AddressCustomFields["ADDRESS_ID"] = "addressId";
})(AddressCustomFields || (exports.AddressCustomFields = AddressCustomFields = {}));
var BadgeType;
(function (BadgeType) {
    BadgeType["TECHNOLOGY"] = "technology";
    BadgeType["COMING_SOON"] = "comingSoon";
    BadgeType["NEW"] = "new";
    BadgeType["SALES_OVERRIDE"] = "salesOverride";
    BadgeType["SALE"] = "sale";
})(BadgeType || (exports.BadgeType = BadgeType = {}));
exports.DEFAULT_BADGE_TEXT_COLOUR = '0, 0, 0, 1';
exports.DEFAULT_BADGE_BACKGROUND_COLOUR = '229, 229, 229, 1';
exports.DEFAULT_SALES_OVERRIDE_BADGE_BACKGROUND_COLOUR = '252, 231, 231, 1';
exports.DEFAULT_SALES_BADGE_BACKGROUND_COLOUR = '252, 231, 231, 1';
var IdMeGroups;
(function (IdMeGroups) {
    IdMeGroups["MILITARY"] = "military";
    IdMeGroups["FIRST_RESPONDER"] = "responder";
    IdMeGroups["TEACHER"] = "teacher";
    IdMeGroups["GOVERNMENT"] = "government";
    IdMeGroups["MEDICAL"] = "medical";
    IdMeGroups["NURSE"] = "nurse";
    IdMeGroups["ALUMNI"] = "alumni";
})(IdMeGroups || (exports.IdMeGroups = IdMeGroups = {}));
exports.idMeCartDiscountKey = 'id-me-groups-discount';
exports.externalTaxCountries = ['US', 'CA'];
var CartDiscountCustomFields;
(function (CartDiscountCustomFields) {
    CartDiscountCustomFields["SHORT_DESCRIPTION"] = "discountShortDescription";
    CartDiscountCustomFields["PROMOTION_LAYOUT_ID"] = "promotionLayoutId";
    CartDiscountCustomFields["PREV_STATE"] = "prevState";
})(CartDiscountCustomFields || (exports.CartDiscountCustomFields = CartDiscountCustomFields = {}));
var LocalizedBooleanValues;
(function (LocalizedBooleanValues) {
    LocalizedBooleanValues["YES"] = "YES";
    LocalizedBooleanValues["NO"] = "NO";
})(LocalizedBooleanValues || (exports.LocalizedBooleanValues = LocalizedBooleanValues = {}));
//# sourceMappingURL=index.js.map